// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3EO9l","content":"LoadingAlert_content__RPTZZ"};